export const dialogMixins = {
  methods: {
    validatePositiveNumber(val) {
      return val > 0;
    },
    validatePositiveIntegerNumber(val) {
      const number = Number(val);
      return this.validatePositiveNumber(val) && Number.isInteger(number);
    },
    validateNumberBetweenRange(min, max, val) {
      return val >= min && val <= max;
    },
    validateNumberBiggerThan(num, val) {
      return val > num;
    },
  },
};
